import { useTranslation } from "react-i18next";
import { mainURL } from "../utils/common";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { RecruitmentResultTrainingLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";

const KMC_Results = () => {
  const { t } = useTranslation();

  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="img" />
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  ">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {RecruitmentResultTrainingLeftMenuList.map(
                      (item, index) => (
                        <RenderNavItem
                          key={item.id || index}
                          item={item}
                          index={index}
                          t={t}
                        />
                      )
                    )}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="">
                <div className="row">
                  <div className="inner-title2 bas">
                    <h3 className="fontSizeClass"> {t("KMC Results")} </h3>
                  </div>
                  <div className="mayor-table health-dept-table">
                    <table
                      width="95%"
                      border={0}
                      align="center"
                      cellPadding={2}
                      cellSpacing={2}
                      className="table table-bordered officials"
                    >
                      <tbody>
                        <tr
                          bgcolor="#302ba0"
                          tabIndex={0}
                          align="center"
                          valign="middle"
                        >
                          <td
                            width="90%"
                            className="text-white tble-brder-left"
                          >
                            {t("Description")}
                          </td>
                          <td width="10%" className="text-white">
                            {t("Date")}
                          </td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18039326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Recruitment Guideline
                            </a>
                          </td>
                          <td>12.09.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18059926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Interview Schedules in the post of Staff Nurse on
                              contractual basis against Adv. No . 03/Kolkata
                              City NUHM Society/2025 - 26. dated 17.11.2025
                            </a>
                          </td>
                          <td>18.03.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18060026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Interview Schedules in the post of Honorary Health
                              Work (HHW) on contractual basis against Adv. No
                              .H/07/KMC/2023 - 24. dated 22.11.2023
                            </a>
                          </td>
                          <td>12.03.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18060126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of eligible candidates for Document
                              Verification and Interview post of Staff Nurse on
                              contractual basis against Adv. No . 03/Kolkata
                              City NUHM Society/2025 - 26. dated 17.11.2025
                            </a>
                          </td>
                          <td>10.03.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18060226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of eligible candidates for Document
                              Verification and Interview post of Honorary Health
                              Work (HHW) on contractual basis against Adv. No .
                              H/07/KMC/2023 - 24. dated 22.11.2023
                            </a>
                          </td>
                          <td>10.03.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18060326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of selected candidates for the post of
                              Specialist Medical Officer for Polyclinics under
                              XV Finance Commission Health Grant under Health
                              Department of KMC on contractual basis Ref: Adv.
                              No . H/06/KMC/2025 - 26. dated 16.01.2026
                            </a>
                          </td>
                          <td>05.03.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18060426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              Further notice for document verification in the
                              post of Accountant-I on contractual basis against
                              Adv. No .02/Kolkata City NUHM Society/2025 - 26.
                              dated 18.10.2025
                            </a>
                          </td>
                          <td>28.02.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18060526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`} >
                              Cancellation of Advertisement no H/03/KMC/2022-23.
                              dated 20.10.2022. for the post of Counsellor
                            </a>
                          </td>
                          <td>23.02.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18060626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of selected candidates for Document
                              Verification and Interview post of Operator for
                              LCMSMS, GCMSMS and ICPMS on contractual basis
                              against Adv. No .H/01/KMC/2025 - 26. dated
                              30.08.2025
                            </a>
                          </td>
                          <td>21.02.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18060726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of selected candidates for the Document
                              Verification post of Accountant-I on contractual
                              basis against Adv. No .02/Kolkata City NUHM
                              Society/2025 - 26. dated 18.10.2025
                            </a>
                          </td>
                          <td>20.02.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18060826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`} >
                              list of selected candidate for the post of Medical
                              Officer for Khidderpore U-CHC under Kolkata City
                              NUHM Society on contractual basis against Adv. No
                              - 05/Kolkata City NUHM Society/2025 - 26. dated
                              06.01.2026
                            </a>
                          </td>
                          <td>13.02.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18060926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidate for the post of Senior
                              Entomologist for Vector Control under Health
                              Department of KMC on contractual basis against
                              Adv. No . H/04/KMC/2025 - 26. dated 09.12.2025
                            </a>
                          </td>
                          <td>03.02.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18061026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of Lab
                              Assistant for Central Lab (Food) under Health
                              Department of KMC on contractual basis against
                              Adv. No H/05/KMC/2025 - 26. dated 06.01.2026
                            </a>
                          </td>
                          <td>02.02.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18061126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates Names and Post for
                              Kolkata District TB Control Society under Health
                              Department of KMC on contractual basis against
                              Memo. No KDTCS/Officer/226/25. dated 06.01.2026
                            </a>
                          </td>
                          <td>06.01.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18061226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Result with respect to the Adv. No H/03/KMC/2025 -
                              26. dated 24.11.2025 for the post of Assistant
                              Analyst and Lab Assistant
                            </a>
                          </td>
                          <td>06.01.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18061326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Medical Officer Specialist for Khiddrpore (U-CHC)
                              under Kolkata City NUHM Society on contractual
                              basis against Adv. No . 04/Kolkata City NUHM
                              Society/2025 - 26. dated 02.12.2025
                            </a>
                          </td>
                          <td>31.12.2025</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18061426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Medical Officer for U-HWC under XV Finance
                              Commission under Health Department of KMC on
                              contractual basis against Adv. No H/02/KMC/2025 -
                              26. dated 19.11.2025
                            </a>
                          </td>
                          <td>15.12.2025</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18061526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates Names and Post for
                              Kolkata District TB Control Society under Health
                              Department of KMC on contractual basis against
                              Memo. No KDTCS/Officer/198/25. dated 13.10.2025
                            </a>
                          </td>
                          <td>15.12.2025</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18061626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Medical Officer on contractual basis under Kolkata
                              City NUHM Society under Health Department of KMC
                              against Adv. No - 01/Kolkata City NUHM
                              Society/2025 - 26. dated 11.09.2025
                            </a>
                          </td>
                          <td>11.09.2025</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18061726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Specialist Medical Officer for Polyclinic under XV
                              Finance Commission Health Grant under Health
                              Department of KMC on contractual basis Ref: Adv.
                              No . H/01/KMC/2024 25. dated 08.06.2024
                            </a>
                          </td>
                          <td>29.07.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18061826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Specialist Medical Officer for Maternity Home
                              under Health Department of KMC on contractual
                              basis Ref: Adv. No . H/10/KMC/2023 24. dated
                              14.03.2024
                            </a>
                          </td>
                          <td>26.06.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18061926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Specialist Medical Officer for Polyclinic under XV
                              Finance Commission and for Khiddrpore (U-CHC)
                              under Kolkata City NUHM Society
                            </a>
                          </td>
                          <td>14.03.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18062026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Medical Officer (Part time) for urban primary
                              health centers in Kolkata City NUHM Society areas
                              on contractual basis against Adv. No - 11/Kolkata
                              City NUHM Society/2023 24. dated 27.01.2024
                            </a>
                          </td>
                          <td>09.03.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18062126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Cancellation of Advertisement
                            </a>
                          </td>
                          <td>05.02.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18062226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Medical Officer (Part time) for urban primary
                              health centers in Kolkata City NUHM Society areas
                              on contractual basis against Adv. No - 10/Kolkata
                              City NUHM Society/2023 24. dated 07.12.2023
                            </a>
                          </td>
                          <td>05.02.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18062326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Specialist Medical Officer for Polyclinic under
                              Health Department KMC on contractual basis against
                              on contractual basis against Adv. No .
                              H/06/KMC/2023 24. dated 07.12.2023
                            </a>
                          </td>
                          <td>22.01.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18062426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidate for the post of
                              Specialist Medical Officer for Khiddrpore (U-CHC)
                              under Kolkata City NUHM Society Adv. No .
                              09/Kolkata City NUHM Society/2023 24. dated
                              07.12.2023
                            </a>
                          </td>
                          <td>22.01.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18062526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              2nd List and 6th List of selected candidates for
                              the post of Medical Officer under XV Finance
                              Commission under Health Department of KMC on
                              contractual basis against Adv. No H/03/KMC/2023
                              24. dated 07.08.2023 and Adv. No H/01/KMC/2022 23.
                              dated 20.10.2022
                            </a>
                          </td> 
                          <td>20.10.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${""}&tenantId=km.kolkata`}>
                              2nd List of selected candidates for the post of Staff Nurse for Polyclinics and Urban Health and Wellness Centers under XV Finance Commission under Health Department of KMC with respect to Adv. No . H/05/KMC/2022-23 dt. 20.12.2022. and Adv. No . H/06/KMC/2022-23 dt. 20.12.2022.
                            </a>
                          </td> 
                          <td>20.12.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18062726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Medical Officer (Part time) for urban primary
                              health centers in Kolkata City NUHM Society areas
                              on contractual basis against Adv. No - 08/Kolkata
                              City NUHM Society/2023 24. dated 07.10.2023
                            </a>
                          </td>
                          <td>15.12.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18062826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              6th list of selected candidates for the post of
                              Staff Nurse (contractual) for urban primary health
                              centers in Kolkata City NUHM Society areas against
                              Adv. No . 04/Kolkata City NUHM Society/2022 23.
                              dated 06.09.2022
                            </a>
                          </td>
                          <td>14.12.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18062926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              6th list of selected candidates for the post of
                              Medical Officer for urban primary health centers
                              in Kolkata City NUHM Society areas on contractual
                              basis against Adv. No - 13/Kolkata City NUHM
                              Society/2022 23. dated 28.01.2023
                            </a>
                          </td>
                          <td>02.12.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18063026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of Staff
                              Nurse for Polyclinics under XV Finance Commission
                              on contractual basis, Health Department, KMC with
                              respect to Adv. No . H/6/KMC/2022-23 dt.
                              20.12.2022
                            </a>
                          </td>
                          <td>16.10.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18063126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of Staff
                              Nurse for Urban Health and Wellness Centres under
                              XV Finance Commission on contractual basis, Health
                              Department, KMC with respect to Adv. No .
                              H/05/KMC/2022-23 dt. 20.12.2022
                            </a>
                          </td>
                          <td>16.10.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18063226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Medical Officer (Part time) for urban primary
                              health centers in Kolkata City NUHM Society areas
                              on contractual basis against Adv. No - 07/Kolkata
                              City NUHM Society/2023 24. dated 21.08.2023
                            </a>
                          </td>
                          <td>13.10.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18063326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              5th list of selected candidates for the post of
                              Medical Officer for urban primary health centers
                              in Kolkata City NUHM Society areas on contractual
                              basis against Adv. No - 13/Kolkata City NUHM
                              Society/2022 23. Dated 28.01.2023
                            </a>
                          </td>
                          <td>13.10.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18063426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              5th list of selected candidates for the post of
                              Staff Nurse (contractual) for urban primary health
                              centers in Kolkata City NUHM Society areas against
                              Adv. No . 04/Kolkata City NUHM Society/2022 23.
                              Dated 06.09.2022
                            </a>
                          </td>
                          <td>13.10.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18063526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Medical Officer (contractual) under XV Finance
                              Commission under Health Department of KMC. Ref:
                              Adv. No H/03/KMC/2023 24. dated 07.08.2023
                            </a>
                          </td>
                          <td>27.09.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18063626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              4th list of selected candidates for the post of
                              Staff Nurse (contractual) for urban primary health
                              centers in Kolkata City NUHM Society areas against
                              Adv. No . 04/Kolkata City NUHM Society/2022 23.
                              Dated 06.09.2022
                            </a>
                          </td>
                          <td>22.09.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18063726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Specialist Medical Officer for Polyclinic under
                              Health Department KMC on contractual basis Ref:
                              Adv. No . H/02/KMC/2023 24. dated 15.07.2023
                            </a>
                          </td>
                          <td>20.09.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18063826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              4th list of selected candidates for the post of
                              Medical Officer for urban primary health centers
                              in Kolkata City NUHM Society areas on contractual
                              basis against Adv. No - 13/Kolkata City NUHM
                              Society/2022 23. dated 28.01.2023
                            </a>
                          </td>
                          <td>14.09.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18063926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              2nd list of selected candidates for the post of
                              Staff Nurse for Khidderpore U-CHC, under Kolkata
                              City NUHM Society on contractual basis against
                              Adv. No . 10 /Kolkata City NUHM Society/2022 23.
                              Dated 12.11.2022
                            </a>
                          </td>
                          <td>05.09.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18064026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              5th list of selected candidates for the post of
                              Medical Officer for Urban Health & Wellness
                              Centers under XV Finance Commission Health - Grant
                              under Health Department of Kolkata Municipal
                              Corporation Ref: Adv. No H/01/KMC/2022 23. Dated
                              20.10.2022
                            </a>
                          </td>
                          <td>05.09.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18064126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                                3rd list of selected candidates for the post of
                                Staff Nurse for urban primary health centers under
                                Kolkata City NUHM Society on contractual basis
                                Ref: Adv. No . 04/Kolkata City NUHM Society/2022
                                23. Dated 06.09.2022
                            </a>
                          </td>
                          <td>26.08.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18064226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Medical Officer (Part time) for urban primary
                              health centers in Kolkata City NUHM Society areas
                              on contractual basis against Adv. No - 04/Kolkata
                              City NUHM Society/2023 24. dated 15.08.2023
                            </a>
                          </td>
                          <td>24.08.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18064326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              2nd list of selected candidate for the post of
                              Medical Officer for Khidderpore U-CHC under
                              Kolkata City NUHM Society on contractual basis
                              against Adv. No - 3/Kolkata City NUHM Society/2023
                              24. Dated 19.06.2023
                            </a>
                          </td>
                          <td>07.08.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18064426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Interview on 11.08.2023,16.08.2023, 18.08.2023,
                              21.08.2023 to 23.08.2023, against Adv. No . No.
                              H/05/KMC/2022-23 dated 20.10.2022. for the post of
                              Staff Nurse (contractual) for Urban Health and
                              Wellness Centres under the XV th Finance
                              Commission Health Grant under the Health
                              Department of Kolkata Municipal Corporation
                            </a>
                          </td>
                          <td>03.08.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18064526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Interview on 07.08.2023 & 09.08.2023, against Adv.
                              No . No. H/06/KMC/2022-23 dated 20.10.2022. for
                              the post of Staff Nurse (contractual) for
                              Polyclinic under the XV th Finance Commission
                              Health Grant under the Health Department of
                              Kolkata Municipal Corporation
                            </a>
                          </td>
                          <td>03.08.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18064626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              2nd list of selected candidate for the post of
                              Laboratory Technician for Khidderpore U-CHC under
                              Kolkata City NUHM Society on contractual basis
                              against Adv. No - 8/Kolkata City NUHM Society/2022
                              23. Dated 12.11.2022
                            </a>
                          </td>
                          <td>02.08.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18064726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              3rd List of selected candidates for the post of
                              Pharmacist for urban primary health centers in
                              Kolkata City NUHM Society areas on contractual
                              basis against Adv. No . 01/Kolkata City NUHM
                              Society/2022 23. dated 05.04.2022
                            </a>
                          </td>
                          <td>02.08.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18064826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for difference post,
                              against Adv. No KDTCS/Office/37/23 dated
                              03.06.2023
                            </a>
                          </td>
                          <td>28.07.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18064926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Medical Officer & Specialist Medical Officer for
                              Khiddrpore (U-CHC) under Kolkata City NUHM Society
                              on contractual basis against Adv. No . 03/Kolkata
                              City NUHM Society/2023 24. dated 19.06.2023 and
                              02/Kolkata City NUHM Society/2023 24. dated
                              06.06.2023
                            </a>
                          </td>
                          <td>25.07.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18065026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              2nd List of selected candidates for the post of
                              Pharmacist for its urban primary health centers in
                              Kolkata City NUHM Society areas on contractual
                              basis against Adv. No . 01/Kolkata City NUHM
                              Society/2022 23.
                            </a>
                          </td>
                          <td>19.07.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18065126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidate for the post of Quality
                              Manager on contractual basis against Adv. No -
                              12/Kolkata City NUHM Society/2022 23. dated
                              15.12.2022
                            </a>
                          </td>
                          <td>14.07.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18065226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Corrigendum to Reference Memo No.
                              KDTCS/Office/68/23. dated 27.06.2023
                            </a>
                          </td>
                          <td>13.07.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18065326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of selected candidate for the post of Analyst for Modified Food Safety on Wheels on Contractual Basis, Under Health Department, Kolkata Municipal Corporation against Adv. No H/04/KMC/2022-23 dt. 23.02.2023
                            </a>
                          </td>
                          <td>11.07.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18065426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Community Health Assistants (Urban) under XV
                              Finance Commission Health Grant,Health Department
                              of Kolkata Municipal Corporation on contractual
                              basis against Adv. No . H/07/KMC/202223. Dated
                              20.10.2022
                            </a>
                          </td>
                          <td>11.07.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18065526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Specialist Medical Officer for Polyclinic under
                              Health Department KMC on contractual basis against
                              on contractual basis against Ref. Adv. No .
                              H/01/KMC/2023 24. dated 06.06.2023
                            </a>
                          </td>
                          <td>10.07.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18065626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              3rd list of selected candidates for the post of
                              Medical Officer for urban primary health centers
                              in Kolkata City NUHM Society areas on contractual
                              basis against Adv. No - 13/Kolkata City NUHM
                              Society/2022 23. Dated 28.01.2023
                            </a>
                          </td>
                          <td>01.07.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18065726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              4th list of selected candidates for the post of
                              Medical Officer for Khidderpore U-CHC under
                              Kolkata City NUHM Society on contractual basis
                              against Adv. No - 7/Kolkata City NUHM Society/2022
                              23. Dated 12.11.2022
                            </a>
                          </td>
                          <td>01.07.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18065826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              4th list of selected candidates for the post of
                              Medical Officer under Health Department KMC on
                              contractual basis against Adv. No H/01/KMC/2022
                              23. Dated 20.10.2022
                            </a>
                          </td>
                          <td>01.07.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18065926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the Computer Test
                              and Interview post of Laboratory Technician, STS,
                              STLS and TBHV against Memo. No.
                              KDTCS/Office/37/23. dated 03.06.2023.
                            </a>
                          </td>
                          <td>27.06.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18066026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Medical Officer (Part time) for urban primary
                              health centers in Kolkata City NUHM Society areas
                              on contractual basis against Adv. No - 01/Kolkata
                              City NUHM Society/2023 24. Dated 12.04.2023.
                            </a>
                          </td>
                          <td>14.06.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18066126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              3rd list of selected candidates for the post of
                              Medical Officer under Health Department KMC on
                              contractual basis against Adv. No H/01/KMC/2022
                              23. Dated 20.10.2022.
                            </a>
                          </td>
                          <td>13.06.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18066226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              The Computer Test & Interview for the post of
                              Quality Manager against Adv. No . 12/Kolkata City
                              NUHM Society/2022 23. dated 15.12.2022 under
                              Kolkata City NUHM Society.
                            </a>
                          </td>
                          <td>09.06.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18066326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Laboratory Technician, Pharmacist, Staff Nurse &
                              Ophthalmic Assistant for Khidderpore U-CHC, under
                              Kolkata City NUHM Society on contractual basis
                              against Adv. No . 08,9,10 & 11/Kolkata City NUHM
                              Society/2022 23. Dated 12.11.2022
                            </a>
                          </td>
                          <td>03.06.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18066426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              2nd list of selected candidates for the post of
                              Medical Officer under XV th Finance Commission,
                              Health Department KMC on contractual basis against
                              Adv. No H/01/KMC/2022 23. Dated 20.10.2022
                            </a>
                          </td>
                          <td>29.05.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18066526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Written Test, Computer Skill Test & Interview
                              against Adv. No . 12/Kolkata City NUHM
                              Society/2022 23. dated 15.12.2022 for the post of
                              Quality Manager (contractual) under the Kolkata
                              City NUHM Society
                            </a>
                          </td>
                          <td>27.05.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18066626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              3rd List of selected candidates for the post of
                              Medical Officer for Khidderpore U-CHC under
                              Kolkata City NUHM Society on contractual basis
                              against Adv. No - 7/Kolkata City NUHM Society/2022
                              23. Dated 12.11.2022
                            </a>
                          </td>
                          <td>27.05.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18066726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the Computer Test
                              on 18.05.2023 post of Pharmacist and Laboratory
                              Technician on contractual basis against Adv. No.
                              08/Kolkata City NUHM Society/2022 23. and
                              09/Kolkata City NUHM Society/2022 23. Dated
                              12.11.2023
                            </a>
                          </td>
                          <td>11.05.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18066826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              2nd list of selected candidates for the post of
                              Medical Officer for Khidderpore U-CHC under
                              Kolkata City NUHM Society on contractual basis
                              against Adv. No - 7/Kolkata City NUHM Society/2022
                              23. Dated 12.11.2022
                            </a>
                          </td>
                          <td>04.05.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18066926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Interview on 04.05.2023 against Adv. No .
                              11/Kolkata City NUHM Society/2022 23. for the post
                              of Ophthalmic Assistant contractual for
                              Khidderpore U-CHC under the Kolkata City NUHM
                              Society
                            </a>
                          </td>
                          <td>28.04.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18067026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Interview on 12.05.2023 & 15.05.2023, against Adv.
                              No . 10/Kolkata City NUHM Society/2022 23. for the
                              post of Staff Nurse contractual for Khidderpore
                              U-CHC under the Kolkata City NUHM Society
                            </a>
                          </td>
                          <td>28.04.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18067126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              2nd List of selected candidates for the post of
                              Medical Officer for urban primary health centers
                              in Kolkata City NUHM Society areas on contractual
                              basis against Adv. No - 13/Kolkata City NUHM
                              Society/2022 23. Dated 28.01.2023
                            </a>
                          </td>
                          <td>18.04.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18067226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              2nd List of selected candidates for the post of
                              Staff Nurse for urban primary health centers in
                              Kolkata City NUHM Society areas on contractual
                              basis against Adv. No . 04/Kolkata City NUHM
                              Society/2022 23. Dated 06.09.2022
                            </a>
                          </td>
                          <td>18.04.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18067326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Medical Officer for urban primary health centers
                              in Kolkata City NUHM Society areas on contractual
                              basis against Adv. No.13/Kolkata City NUHM
                              Society/2022 23. Dated 28.01.2023
                            </a>
                          </td>
                          <td>10.03.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18067426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of Staff
                              Nurse for urban primary health centers in Kolkata
                              City NUHM Society areas on contractual basis
                              against Adv. No . 04/Kolkata City NUHM
                              Society/2022 23. dated 06.09.2022
                            </a>
                          </td>
                          <td>24.02.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18067526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                             List of selected candidates for the post of Medical Officer (Part time) for urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No - 06/Kolkata City NUHM Society/2022 – 23. Dated 13.01.2023
                            </a>
                          </td>
                          <td>22.02.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18067626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Specialist Medical Officer for Polyclinic under
                              Health Department KMC on contractual basis against
                              on contractual basis against Adv. No .
                              H/02/KMC/2022 23. dated 20.10.2022
                            </a>
                          </td>
                          <td>01.02.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18067726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Medical Officer under Health Department KMC on
                              contractual basis against Adv. No H/01/KMC/2022
                              23. Dated 20.10.2022
                            </a>
                          </td>
                          <td>01.02.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18067826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Specialist Medical Officer Medical Officer for
                              Khiddrpore (U-CHC) under Kolkata City NUHM Society
                              on contractual basis against Adv. No . 07/Kolkata
                              City NUHM Society/2022 23. dated 12.11.2022
                            </a>
                          </td>
                          <td>30.01.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18067926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of selected candidates for the post of
                              Community Health Assistants (Urban) for its urban
                              primary health centers in Kolkata City NUHM
                              Society areas on contractual basis against Adv. No
                              . 03/Kolkata City NUHM Society/2022 23. Dated
                              22.07.2022
                            </a>
                          </td>
                          <td>30.01.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18068026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`} >
                              An Interview for Staff Nurse on contractual basis against Adv. No .04/Kolkata City NUHM Society/2022 – 23. Dated 06.09.2022
                            </a>
                          </td>
                          <td>08.12.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18068126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`} >
                              6th List of selected candidates for the post of
                              Medical Officer for its urban primary health
                              centers in Kolkata City NUHM Society areas on
                              contractual basis against Adv. No . 02/Kolkata
                              City NUHM Society/2022 23. Dated 26.04.2022
                            </a>
                          </td>
                          <td>26.11.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18068226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`} >
                              5th List of selected candidates for the post of Medical Officer for its urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv.No. 02/Kolkata City NUHM Society/2022 – 23. Dated 26.04.2022
                            </a>
                          </td>
                          <td>05.11.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18068326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of shortlisted candidates called for
                              interview for the post of 32 nos. Community
                              Organiser as per Advt. No. KMC/NULM/01/2021-2022
                              dated 02.08.2021
                            </a>
                          </td>
                          <td>21.10.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18068426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of selected candidates for the post of Medical Officer(part time) for its urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No . 05/Kolkata City NUHM Society/2022 – 23. Dated 09.09.2022
                            </a>
                          </td>
                          <td>18.10.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18068526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              4th List of selected candidates for the post of Medical Officer for its urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No . 02/Kolkata City NUHM Society/2022 – 23. Dated 26.04.2022
                            </a>
                          </td>
                          <td>14.10.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18068626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              3rd List of selected candidates for the post of
                              Medical Officer for its urban primary health
                              centers in Kolkata City NUHM Society areas on
                              contractual basis against Adv. No . 02/Kolkata
                              City NUHM Society/2022 23. Dated 26.04.2022
                            </a>
                          </td>
                          <td>31.08.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18068726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              2nd List of selected candidates for the post of Medical Officer for its urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No . 02/Kolkata City NUHM Society/2022 – 23. Dated 26.04.2022
                            </a>
                          </td>
                          <td>29.07.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18068826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of selected candidates for the Computer Test
                              post of Pharmacist on contractual basis against
                              Adv. No .01/Kolkata City NUHM Society/2022 23
                            </a>
                          </td>
                          <td>19.07.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18068926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              4th list of selected candidates for the post of Staff Nurse (contractual) for its urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No .02/Kolkata City NUHM Society/2021 – 22. Dated 04.05.2021
                            </a>
                          </td>
                          <td>23.06.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18069026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Medical officer & Medical officer (part time) on
                              contractual basis for its urban primary health
                              centers in Kolkata City NUHM Society areas on
                              contractual basis against Adv. No. 02/Kolkata City
                              NUHM Society/2022 23
                            </a>
                          </td>
                          <td>16.06.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18069126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidate for the post of
                              Accounts Assistant on contractual basis against
                              Adv. No 08/Kolkata City NUHM Society/2021-22.
                              Dated 18.11.2021
                            </a>
                          </td>
                          <td>05.04.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18069226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Medical Officer & Medical Officer part time for
                              its urban primary health centers in Kolkata City
                              NUHM Society areas on contractual basis against
                              Adv. No . 10/Kolkata City NUHM Society/2021 22.
                            </a>
                          </td>
                          <td>05.04.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18069326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              2nd List of selected candidates for the post of
                              Pharmacist for its urban primary health centers in
                              Kolkata City NUHM Society areas on contractual
                              basis against Adv. No . 03/Kolkata City NUHM
                              Society/2021 22.dated 06.05.2021
                            </a>
                          </td>
                          <td>31.03.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18069426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of Laboratory Technician 
                              for its urban primary health centers in Kolkata City NUHM Society areas on 
                              contractual basis against Adv. No . 09/Kolkata City NUHM Society/2021 – 22. Dated 22.11.2021.
                            </a>
                          </td>
                          <td>04.03.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18069526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Interview on 08.03.2022, against Adv. No . 08/Kolkata City NUHM Society/2021 – 22. 
                              for the post of Accounts Assistant contractual under the Kolkata City NUHM Society.
                            </a>
                          </td>
                          <td>28.02.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18069626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Medical Officer & Medical Officer part time for its urban primary health centers in Kolkata City NUHM Society 
                              areas on contractual basis against Adv. No . 07/Kolkata City NUHM Society/2021 – 22.
                            </a>
                          </td>
                          <td>03.02.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18069726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the Compute Test post of Laboratory Technicians against 
                              Adv. No. 09/Kolkata City NUHM Society/2021-22. Under Kolkata City NUHM Society.
                            </a>
                          </td>
                          <td>31.01.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18069826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the Compute Test post of Accounts Assistant against 
                              Adv. No. 08/Kolkata City NUHM Society/2021-22. Under Kolkata City NUHM Society.
                            </a>
                          </td>
                          <td>31.01.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18069926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of ANM (contractual) for its urban primary health centers in Kolkata City
                               NUHM Society areas on contractual basis against Adv. Memo No . 227/NUHM/KOL/19 – 20/Dated 14/06/2019.
                            </a>
                          </td>
                          <td>25.01.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18070026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              3rd list of selected candidates for the post of Staff Nurse (contractual) for its urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No . 02/Kolkata City NUHM Society/2021 – 22.
                            </a>
                          </td>
                          <td>10.01.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18070126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Pharmacist (on contractual basis) for its urban
                              primary health centers in Kolkata City NUHM
                              Society areas against Adv. No . 03/Kolkata City
                              NUHM Society/2021 22
                            </a>
                          </td>
                          <td>10.01.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18070226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                             list of selected candidate for the post of Sub-Registrars on contractual basis for its 
                             Burning Ghats/Burial Grounds in Kolkata Municipal Corporation areas against Adv. No . H/01/KMC/2021 – 22. Dated 12.06.2021
                            </a>
                          </td>
                          <td>17.11.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18070326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`} >
                              List of selected candidates for the post of Medical officer & Medical officer (part time) on contractual basis for its urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No . 06/Kolkata City NUHM Society/2021 – 22. Dt. 28.08.2021
                            </a>
                          </td>
                          <td>08.10.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18070426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              2nd list of selected candidates for the post of
                              Staff Nurse (contractual) for its urban primary
                              health centers in Kolkata City NUHM Society areas
                              on contractual basis against Adv. No . 02/Kolkata
                              City NUHM Society/2021 22
                            </a>
                          </td>
                          <td>24.09.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18070526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the Computer Test
                              post of Pharmacist on contractual basis against
                              Adv. No .03/Kolkata City NUHM Society/2021 22
                              under Kolkata City NUHM Society
                            </a>
                          </td>
                          <td>16.09.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18070626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                             3rd List of selected candidates for the post of Laboratory Technicians against Adv. No. 03/Kolkata City NUHM Society/2020-21. Under Kolkata City NUHM Society
                            </a>
                          </td>
                          <td>09.08.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18070726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of Sub-Registrars on contractual basis for its Burning Ghats/Burial Grounds in Kolkata Municipal Corporation areas on contractual basis against Adv. No . H/01/KMC/2021 – 22. Dated 12.06.2021
                            </a>
                          </td>
                          <td>20.07.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18070826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Medical officer & Medical officer (part time) on
                              contractual basis for its urban primary health
                              centers in Kolkata City NUHM Society areas on
                              contractual basis against Adv. No . 05/Kolkata
                              City NUHM Society/2021 22
                            </a>
                          </td>
                          <td>20.07.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18070926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`} >
                              Corrigendum to Staff Nurse, Advertisement No. 02/Kolkata City NUHM Society/2021-22.Call date is change from 01.07.2021 and 02.07.2021.
                            </a>
                          </td>
                          <td>30.06.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18071026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of selected candidates for the post of Staff Nurse (contractual) for its urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No . 02/Kolkata City NUHM Society/2021 – 22.
                            </a>
                          </td>
                          <td>26.06.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18071126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of selected candidates for the post of Medical officer part time (on contractual basis) for its urban primary health 
                              centers in Kolkata City NUHM Society areas on contractual basis against Adv. No . 04/Kolkata City NUHM Society/2021 – 22.
                            </a>
                          </td>
                          <td>09.06.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18071226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of selected candidates for the post of
                              Medical officer (contractual) for its urban
                              primary health centers in Kolkata City NUHM
                              Society areas on contractual basis against Adv. No
                              . 01/Kolkata City NUHM Society/2021 22.
                            </a>
                          </td>
                          <td>29.05.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18071326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              2nd list of selected candidates for the post of
                              Laboratory Technicians against Adv. No. 03/Kolkata
                              City NUHM Society/2020-21. Under Kolkata City NUHM
                              Society.
                            </a>
                          </td>
                          <td>29.05.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18071426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              4th list of selected candidates for the post of
                              Staff Nurse (contractual) for its urban primary
                              health centers in Kolkata City NUHM Society areas
                              on contractual basis against Adv. No . 11/Kolkata
                              City NUHM Society/2019 20.
                            </a>
                          </td>
                          <td>30.12.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18071526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              5th List of selected candidates for5th List of selected candidates for the post of Pharmacist for its urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No . 03/Kolkata City NUHM Society/2019 – 20.
                            </a>
                          </td>
                          <td>17.12.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18071626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of selected candidates for the post of Medical officer full time & Medical officer part time (on contractual basis) for its urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No. 06/Kolkata City NUHM Society/2020 – 21.
                            </a>
                          </td>
                          <td>08.12.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18071726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                            3rd list of selected candidates for the post of Staff Nurse (contractual) for its urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No.11/Kolkata City NUHM Society/2019 – 20
                            </a>
                          </td>
                          <td>24.11.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18071826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              4th List of selected candidates for the post of Pharmacist for its urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No .03/Kolkata City NUHM Society/2019 – 20.
                            </a>
                          </td>
                          <td>24.11.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a  href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18071926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`} >
                            List of selected candidates for the post of Medical officer full time & Medical officer part time (on contractual basis) for its urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No.05/Kolkata City NUHM Society/2020 – 21
                            </a>
                          </td>
                          <td>15.10.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18072026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of selected candidates and Panel for the post
                              of Laboratory Technician (on contractual basis)
                              for its urban primary health centers in Kolkata
                              City NUHM Society areas on contractual basis
                              against Adv. No . 03/Kolkata City NUHM
                              Society/2020 21
                            </a>
                          </td>
                          <td>07.10.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18072126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              2nd list of selected candidates for the post of
                              Staff Nurse (contractual) for its urban primary
                              health centers in Kolkata City NUHM Society areas
                              on contractual basis against Adv. No . 11/Kolkata
                              City NUHM Society/2019 20
                            </a>
                          </td>
                          <td>05.10.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18072226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              3rd List of selected candidates for the post of
                              Pharmacist for its urban primary health centers in
                              Kolkata City NUHM Society areas on contractual
                              basis against Adv. No .03/Kolkata City NUHM
                              Society/2019 20.
                            </a>
                          </td>
                          <td>30.09.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18072326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of
                              Medical officer full time & Medical officer part
                              time (on contractual basis) for its urban primary
                              health centers in Kolkata City NUHM Society areas
                              on contractual basis against Adv. No . 04/Kolkata
                              City NUHM Society/2020 21
                            </a>
                          </td>
                          <td>29.09.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18072426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of selected candidates for the Compute Test
                              post of Laboratory Technicians against Adv. No.
                              03/Kolkata City NUHM Society/2020-21. Under
                              Kolkata City NUHM Society
                            </a>
                          </td>
                          <td>18.09.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18072526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of selected candidates for the post of Medical officer full time & Medical officer part time for its urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No . 02/Kolkata City NUHM Society/2020 – 21
                            </a>
                          </td>
                          <td>02.09.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18072626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              4List of selected candidates for the post of Staff
                              Nurse for its urban primary health centers in
                              Kolkata City NUHM Society areas on contractual
                              basis against Adv. No. 11/Kolkata City NUHM
                              Society/2019 20
                            </a>
                          </td>
                          <td>10.08.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18072726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of selected candidates for the post of Urban
                              Health Planning & Monitoring Manager (on
                              contractual basis) under Kolkata City NUHM Society
                              against Adv. No . 07/Kolkata City NUHM
                              Society/2019 20
                            </a>
                          </td>
                          <td>10.08.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18072826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              4th List of selected candidates for the post of Laboratory Technician (on contractual basis) for its urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No . 011/Kolkata City NUHM Society/2018 – 19
                            </a>
                          </td>
                          <td>27.07.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18072926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of selected candidates Medical Office (full
                              time) & Medical Officer (Part time) on contractual
                              basis for its urban primary health centers in
                              Kolkata City NUHM Society against advertisement no
                              01/Kolkata City NUHM Society/2020-21
                            </a>
                          </td>
                          <td>17.07.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18073026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              LIST OF SELECTED CANDIDATES FOR THE POST OF
                              MEDICAL OFFICER FULL TIME & PART TIME ON
                              CONSTRACTUAL BASIS UNDER KOLKATA CITY NUHM SOCIETY
                              . ADVERTISEMENT NO- 10/KOLKATA CITY NUHM
                              SOCIETY/2019-20
                            </a>
                          </td>
                          <td>16.03.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18073126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                             The Computer Test for the post of Urban Health Planning & Monitoring Manager against Adv. No . 07/Kolkata City NUHM Society/2019 – 20. under Kolkata City NUHM Society.
                            </a>
                          </td>
                          <td>13.03.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18073226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              2nd List of selected candidates for the post of Staff Nurse (contractual) for its urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No . 04/Kolkata City NUHM Society/2019 – 20
                            </a>
                          </td>
                          <td>27.02.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18073326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                            2nd List of selected candidates for the post of Pharmacist for its urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No . 03/Kolkata City NUHM Society/2019 – 20
                            </a>
                          </td>
                          <td>24.02.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18073426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of selected candidates for the post of
                              Medical officer full time & Medical officer part
                              time (on contractual basis) for its urban primary
                              health centers in Kolkata City NUHM Society areas
                              on contractual basis against Adv. No . 09/Kolkata
                              City NUHM Society/2019 20
                            </a>
                          </td>
                          <td>20.02.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18073526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              3rd List of selected candidates for the post of
                              Laboratory Technician (on contractual basis) for
                              its urban primary health centers in Kolkata City
                              NUHM Society areas on contractual basis against
                              Adv. No . 011/Kolkata City NUHM Society/2018 19.
                            </a>
                          </td>
                          <td>22.01.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18073626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`} >
                              List of selected candidates for the post of
                              Medical officer full time & Medical officer part
                              time (on contractual basis) for its urban primary
                              health centers in Kolkata City NUHM Society areas
                              on contractual basis against Adv. No . 08/Kolkata
                              City NUHM Society/2019 20.
                            </a>
                          </td>
                          <td>20.01.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18073726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              Panel for engagement of auto CAD Professional,
                              following Reservation Rules, prepared on the basis
                              of 'Merit Panel' forwarded by Interview Board,
                              following Resarvation Rules.
                            </a>
                          </td>
                          <td>16.01.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18073826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of selected candidates for the post of Medical officer part time (contractual) for its urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No . 07/Kolkata City NUHM Society/2019 – 20.
                            </a>
                          </td>
                          <td>24.12.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18073926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of selected candidates for the post of
                              Pharmacist for its urban primary health centers in
                              Kolkata City NUHM Society areas on contractual
                              basis against Adv. No . 03/Kolkata City NUHM
                              Society/2019 20.
                            </a>
                          </td>
                          <td>20.12.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18074026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              POST OF MANAGER MIS & ME UNDER DAY -NULM IN K.M.C
                            </a>
                          </td>
                          <td>05.12.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18074126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of selected candidates for the post of
                              Medical officer full time and Medical officer part
                              time for its urban primary health centers in
                              Kolkata City NUHM Society areas on contractual
                              basis against Adv. No . 06/Kolkata City NUHM
                              Society/2019 20
                            </a>
                          </td>
                          <td>25.11.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18074226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              The Computer Test for The Post of Pharmacist under
                              Kolkata City NUHM Society as per advertisement
                              No.03/Kolkata City NUHM Society/2019-20 will be
                              held from 18.11.2019 To 22.11.2019 at Institute of
                              Urban Management I.U.M, 36c, Ballygaung Circular
                              Road, Kolkata -700019 as per attached listed
                              schedule.
                            </a>
                          </td>
                          <td>15.11.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18074326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`} >
                              List of selected candidates for the post of Staff
                              Nurse (contractual) for its urban primary health
                              centers in Kolkata City NUHM Society areas on
                              contractual basis against Adv. No . 04/Kolkata
                              City NUHM Society/2019 20.
                            </a>
                          </td>
                          <td>11.11.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18074426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              Corrigendum to Memo No: 227/NUHM/KOL/19-20. Call
                              date is change from 31.09.2019 to 31.10.2019 and
                              01.10.2019 to 01.11.2019.
                            </a>
                          </td>
                          <td>31.10.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18074526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List Of Selected Candidates For The Post Of (ANM)
                              Two years Training Course Under Kolkata City NUHM
                              Society as per Advertisement No-
                              227/NUMH/KOL/19-20 are requested to report on
                              31.10.2019 & 01.11.2019
                            </a>
                          </td>
                          <td>26.10.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18074626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              LIST OF SELECTED CANDIDATES FOR THE POST OF
                              MEDICAL OFFICER (FULL TIME) & (PART TIME).
                              ADVERTISEMENT NO- 05/KOLKATA CITY NUHM
                              SOCIETY/2019-20
                            </a>
                          </td>
                          <td>26.10.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18074726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              The shortlisted names for the post of Staff Nurse
                              under Kolkata City NUHM Society as per
                              advertisement No 04/Kolkata City NUHM
                              Society/2019-20 are requested to report on
                              19.10.2019
                            </a>
                          </td>
                          <td>16.10.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${""}&tenantId=km.kolkata`}>
                              LIST OF SELECTED CANDIDATES FOR THE POST OF LABORATORY TECHNICIAN. ADVERTISEMENT NO- 11/KOLKATA CITY NUHM SOCIETY/2018-19
                            </a>
                          </td>
                          <td>21.09.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18074826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              LIST OF SELECTED CANDIDATES FOR THE POST OF
                              MEDICAL OFFICER (FULL TIME) & (PART TIME).
                              ADVERTISEMENT NO- 03/KOLKATA CITY NUHM
                              SOCIETY/2019-20
                            </a>
                          </td>
                          <td>24.08.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18074926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              ENGAGEMENT & FINAL EXAMINATION RESULT OF TWO YEARS
                              ANM COURES, UNDER KOLKATA CITY NUHM SOCIETY . MEMO
                              NO:-523/2019/2742
                            </a>
                          </td>
                          <td>22.08.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18075026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              LIST OF SELECTED CANDIDATES FOR THE POST OF
                              LABORATORY TECHNICIAN. ADVERTISEMENT NO-
                              11/KOLKATA CITY NUHM SOCIETY/2018-19
                            </a>
                          </td>
                          <td>06.08.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18075126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              "Evaluation" of the candidates qualified for the
                              General (Non Technical) cadre
                            </a>
                          </td>
                          <td>03.08.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18075226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              Evaluation" of the candidates qualified for the
                              General (Technical) cadre
                            </a>
                          </td>
                          <td>03.08.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18075326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              LIST OF SELECTED CANDIDATES FOR THE POST OF
                              MEDICAL OFFICER (FULL TIME) & (PART TIME).
                              ADVERTISEMENT NO- 02/KOLKATA CITY NUHM
                              SOCIETY/2019-20
                            </a>
                          </td>
                          <td>09.07.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18075426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`} >
                              LIST OF SELECTED CANDIDATES FOR THE POST OF
                              MEDICAL OFFICER (FULL TIME) & (PART TIME).
                              ADVERTISEMENT NO- 01/KOLKATA CITY NUHM
                              SOCIETY/2019-20
                            </a>
                          </td>
                          <td>25.06.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18075526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              CORRIGENDUM regarding Recruitment of Technical
                              Personnel AutoCAD Professional & Assistant
                              AutoCAD Professional (On contractual service
                              purely on temporary basis)
                            </a>
                          </td>
                          <td>12.03.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18075626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of Qualified Candidates for Personality Test
                              of AutoCAD Professional.
                            </a>
                          </td>
                          <td>09.03.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18075726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of Qualified Candidates for Personality Test
                              of Assistant AutoCAD Professional.
                            </a>
                          </td>
                          <td>09.03.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18075826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                            3RD LIST OF SELECTED CANDIDATES (UR-25; OBC-B - 5) FOR THE POST OF STAFF NURSE UNDER KOLKATA CITY NUHM SOCIETY AGAINST ADVERTISEMENT NO. 3/KOLKATA CITY NUHM SOCIETY/2018-2019
                            </a>
                          </td>
                          <td>12.12.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18075926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              LIST OF SELECTED CANDIDATES FOR THE POST OF
                              MEDICAL OFFICER (PART-TIME) ON CONTRACTUAL BASIS
                              UNDER KOLKATA CITY NUHM SOCIETY AGAINST
                              ADVERTISEMENT NO. 6/KOLKATA CITY NUHM
                              SOCIETY/2018-2019
                            </a>
                          </td>
                          <td>31.10.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18076026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                            LIST OF SELECTED UR (FORTY-FOUR CANDIDATES), OBC-B (SIX CANDIDATES) FOR THE POST OF STAFF NURSE UNDER KOLKATA CITY NUHM SOCIETY; REF: ADVERTISEMENT NO. 3/KOLKATA CITY NUHM SOCIETY/2018-2019
                            </a>
                          </td>
                          <td>04.10.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18076126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Answer keys of examinations under NULM vide Advt.
                              No. KMC/AMRUT/NULM-01/2016-17 dt. 16/06/16
                            </a>
                          </td>
                          <td>11.09.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18076226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              list of selected candidates for interview for the post of Manager-MIS & ME under NULM
                            </a>
                          </td>
                          <td>11.09.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18076326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              Interview list for the post of AUTO-CAD Professionals(Contractual)
                            </a>
                          </td>
                          <td>29.08.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18076426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`} >
                              Interview list for the post of Assistant AUTO-CAD
                              Professionals(Contractual)
                            </a>
                          </td>
                          <td>29.08.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18076526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              CORRIGENDUM TO THE LIST OF SELECTED OBC-A (TWENTY
                              ONE CANDIDATES) FOR THE POST OF STAFF NURSE UNDER
                              KOLKATA CITY NUHM SOCIETY REF: ADVERTISEMENT NO.
                              3/KOLKATA CITY NUHM SOCIETY / 2018-2019, DATED -
                              02.06.2018
                            </a>
                          </td>
                          <td>14.08.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18076626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`} >
                              LIST OF SELECTED (UR-61; OBC-A-21; OBC-B-17; SC-53
                              & ST-5) CANDIDATES FOR THE POST OF STAFF NURSE
                              UNDER KOLKATA CITY NUHM SOCIETY, AGAINST
                              ADVERTISEMENT NO. 3/KOLKATA CITY NUHM SOCIETY /
                              2018-2019, DATED - 02.06.2018
                            </a>
                          </td>
                          <td>10.08.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18076726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of successful candidates recommended for
                              engagement to the post of Veterinary Officer on
                              contractual basis
                            </a>
                          </td>
                          <td>07.08.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18076826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                            LIST OF SELECTED CANDIDATES SC (ELEVEN CANDIDATES), MERITORIOUS SPORTS PERSON (ONE CANDIDATE), 
                            OBC-A (TWO CANDIDATES), OBC-B(ONE CANDIDATE) FOR THE POST OF LABORATORY TECHNICIAN UNDER 
                            KOLKATA CITY NUHM SOCIETY, AGAINST ADV. NO. 14/KOLKATA CITY NUHM SOCIETY/2017-2018, DATED - 02.08.2018
                            </a>
                          </td>
                          <td>04.08.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18076926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              LIST OF SELECTED CANDIDATES FOR THE POST OF
                              PHARMACISTS (UR-PH; UR-EX.SERVICEMAN; ST) AGAINST
                              ADV. NO. 13/KOLKATA CITY NUHM SOCIETY/ 2017-2018,
                              DATED. 09.02.2018
                            </a>
                          </td>
                          <td>27.07.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18077026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              LIST OF SELECTED CANDIDATES FOR COMPUTER TEST AND
                              INTERVIEW FOR THE POST OF LABORATORY TECHNICIAN,
                              AGAINST ADV. NO. 14/KOLKATA CITY NUHM SOCIETY/
                              2017/2018, DATED. 19.03.2018
                            </a>
                          </td>
                          <td>20.06.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18077126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              LIST OF SELECTED CANDIDATES FOR COMPUTER TEST AND
                              INTERVIEW FOR THE POST OF PHARMACIST UNDER KOLKATA
                              CITY NUHM SOCIETY, AGAINST ADV. NO. 13/KOLKATA
                              CITY NUHM SOCIETY/2017-2018, DATED - 09.02.2018
                            </a>
                          </td>
                          <td>04.06.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${""}&tenantId=km.kolkata`}>
                            Final Merit List for Engagement of Contractual Teachers in KMCP Schools.
                            </a>
                          </td>
                          <td>08.03.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18077226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              Notice for Verification of documents in original
                              and interview of successful candidates to be
                              engaged as Contractual Teacher in the KMCP
                              Schools.
                            </a>
                          </td>
                          <td>16.02.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${""}&tenantId=km.kolkata`}>
                            Publication of Written Examination of Contractual Teachers of KMCP Schools.
                            </a>
                          </td>
                          <td>07.02.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18077326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              PANEL OF SELECTED SPECIALISTS FOR ENGAGEMENT OF
                              GYNECOLOGISTS & ANESTHETISTS ON CASE TO CASE BASIS
                              UNDER KOLKATA MUNICIPAL CORPORATION
                              WALK-IN-INTERVIEW HELD ON 18.12.2017
                            </a>
                          </td>
                          <td>18.01.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18077426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              LIST OF SELECTED CANDIDATES (UR-20, SC-46,
                              OBC-B-9, OBC-A-21, ST-1 & UR-PWD-1), AGAINST
                              ADVERTISEMENT NO. 09/KOLKATA CITY NUHM
                              SOCIETY/2017-18, DATED - 17.11.2017
                            </a>
                          </td>
                          <td>04.01.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18077526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              SIXTH LIST OF SELECTED UNRESERVED CANDIDATES FOR
                              THE POST OF LABORATORY TECHNICIAN UNDER KOLKATA
                              CITY NUHM SOCIETY, RE:ADVT. NO. - 10/KOLKATA CITY
                              NUHM SOCIETY/2016-17, DATED - 09.03.2017
                            </a>
                          </td>
                          <td>22.01.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18077626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              THIRD LISTS OF (UR, OBC-B) CATEGORIES OF
                              LABORATORY TECHNICIANS & SECOND LISTS OF (UR,
                              OBC-A & B, S.C.) CATEGORIES OF PHARMACISTS UNDER
                              KOLKATA CITY NUHM SOCITY AGAINST ADV NO.10/KOLKATA
                              CITY NUHM SOCITY/2016-17, DTD-09.03.2017 &
                              7/KOLKATA CITY NUHM SOCITY/2016-17, DTD-03.12.2016
                              RESPECTIVELY
                            </a>
                          </td>
                          <td>05.09.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18077726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              SECOND LIST OF SELECTED UR, OBC-A, OBC-B
                              CATEGORIES OF CANDIDATES FOR THE POST OF
                              LABORATORY TECHNICIANS UNDER KOLKATA CITY NUHM
                              SOCIETY AGAINST ADV. NO. 10/KOLKATA CITY NUHM
                              SOCIETY / 2016-17, DATED-09.03.2017
                            </a>
                          </td>
                          <td>20.07.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18077826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              LIST OF SELECTED UR, OBC-A, PWD (PH), OBC-B & SC
                              CATEGORIES OF CANDIDATES FOR THE POST OF
                              PHARMACIST UNDER KOLKATA CITY NUHM SOCIETY AGAINST
                              ADV. NO. 7/KOLKATA CITY NUHM SOCIETY / 2016-17,
                              DATED-03.12.2016
                            </a>
                          </td>
                          <td>18.07.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18077926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              SECOND LIST OF SELECTED ANM TRAINEE FROM PANEL
                              DTD. 03.04.2017
                            </a>
                          </td>
                          <td>19.06.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18078026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              Corrigendum to the list of UR candidate
                            </a>
                          </td>
                          <td>24.05.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18078126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              RESULT OF ALL CATEGORIES OF LAB. TECHNICIAN,
                              AGAINST ADV. 10/KOLKATA CITY NUHM SOCIETY /
                              2016-17, DATED. 09.03.2017
                            </a>
                          </td>
                          <td>23.05.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18078226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              RE:ADVERTISEMENT NO. 07/KOLKATA CITY NUHM SOCIETY
                              / 2016-17, DTD. 03.12.2016 ALL CATEGORY - GEN,
                              SC, ST, OBC-A, OBC-B, (PH, UR & SC & ST-SPORTS)
                            </a>
                          </td>
                          <td>24.04.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18078326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                            CORRIGENDUM--AGAINST RE:Advertisement No. – 10/Kolkata City NUHM Society / 2016-17 DT. 09.03.17 VENUE OF COMPUTER 
                            TEST - INSTITUTE OF URBAN MANAGEMENT (IUM), 36C, Ballygaung Circular Road, Kolkata – 700 019 (Ballygaung phanri crossing)..
                            </a>
                          </td>
                          <td>24.04.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18078426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              LIST OF 7 NOS OF CONTRACTUAL MEDICAL OFFICER (VIDE
                              ADV. NO. 1 / KOLKATA CITY NUHM SOCIETY / 2017-2018
                              DATED- 07.04.2017).
                            </a>
                          </td>
                          <td>20.04.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18078526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              FIRST LIST OF 20 NOS OF CONTRACTUAL STAFF NURSES
                              (VIDE ADV. PUBLISHED IN BARTAMAN PATRIKA &
                              OFFICIAL WEBSITE OF K.M.C. ON 16/02/2017 AND
                              INTERVIEW HELD ON 04.03.2017).
                            </a>
                          </td>
                          <td>10.04.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18078626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`} >
                              THIRD LIST OF SELECTED (UNRESERVED & OBC-B)
                              CANDIDATES, AGAINST ADVERTISEMENT NO. 3/KOLKATA
                              CITY NUHM SOCIETY / 2016-2017, DATED. 09.08.2016.
                            </a>
                          </td>
                          <td>04.04.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18078726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              LIST OF SELECTED PART-TIME MEDICAL OFFICERS,
                              AGAINST ADVERTISEMENT NO. 9 / KOLKATA CITY NUHM
                              SOCIETY / 2016-2017, DATED 03.03.2017.
                            </a>
                          </td>
                          <td>23.03.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18078826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              SELECTED ALL CATEGORIES OF TRAINEE ANM CANDIDATES
                              UNDER KOLKATA CITY NUHM SOCIETY, AGAINST
                              ADVERTISEMENT NO. NFW/NUHM-232/2016-3826,
                              DT.09.12.2016.
                            </a>
                          </td>
                          <td>03.02.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a  href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18078926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              SELECTED 2ND LIST OF STAFF NURSE (UR, SC, OBC-B)
                              AGAINST ADVERTISEMENT NO. 3/KOLKATA CITY NUHM
                              SOCIETY/2016-17, DATED. 09.08.2016.
                            </a>
                          </td>
                          <td>20.01.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18079026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              SELECTED LIST OF FULL-TIME MEDICAL OFFICERS (ALL
                              CATEGORIES) UNDER KOLKATA CITY NUHM SOCIETY.
                            </a>
                          </td>
                          <td>13.01.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18079126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              LIST OF SELECTED STAFF NURSE (ALL CADRE) UNDER KOLKATA CITY NUHM SOCIETY FOR THE YEAR 2016-17.
                            </a>
                          </td>
                          <td>16.11.2016</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18079226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              The list of selected Medical Officer (Full Time)
                              purely on contractual basis for Kolkata City NUHM
                              Society.
                            </a>
                          </td>
                          <td>17.10.2016</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18079326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              List of selected candidates for the post of
                              Medical Officer (Full Time) Contractual under
                              Kolkata City NUHM Society.
                            </a>
                          </td>
                          <td>01.09.2016</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18079426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              Selected Candidate for the Post of Data Manager
                              under Kolkata City NUHYM Society.
                            </a>
                          </td>
                          <td>04.08.2016</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18079526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              Selected Medical Officers (Part Time) of Kolkata
                              City NUHM Society in Interview dated 15/07/2016.
                            </a>
                          </td>
                          <td>30.07.2016</td>
                        </tr>

                        {/* <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18079626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              Selected candidates for the post of Data Entry
                              Operator and Computer Assistant under Kolkata City
                              NUHM Society.
                            </a>
                          </td>
                          <td>18.07.2016</td>
                        </tr> */}
                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${""}&tenantId=km.kolkata`}>
                            Name of the candidate selected for the post of ACCOUNTS MANAGER under Kolkata City NUHM Society.
                            </a>
                          </td>
                          <td>04.03.2016</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${""}&tenantId=km.kolkata`}>
                            List of the successful candidates for the deployment of Apprentices trainee in KMC.
                            </a>
                          </td>
                          <td>25.02.2016</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${""}&tenantId=km.kolkata`}>
                            List of selected Part-time MO (on the basis of the result of Walk-in interview dt 11.01.16) under Kolkata City NUHM Society.
                            </a>
                          </td>
                          <td>20.02.2016</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${""}&tenantId=km.kolkata`}>
                            Notice For Interview of Hearing Officer.
                            </a>
                          </td>
                          <td>21.01.2016</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${""}&tenantId=km.kolkata`}>
                            Selected Candidates for staff Nurses (contractual) for Boral TB Hospital in interview (26.11.2015).
                            </a>
                          </td>
                          <td>02.12.2015</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18079726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              MERIT LIST OF MEDICAL OFFICER (RESERVED CATEGORY)
                              THROUGH WALK-IN INTERVIEW HELD ON 14/09/2015 UNDER
                              KOLKATA CITY NUHM SOCIETY, KMC.
                            </a>
                          </td>
                          <td>09.10.2015</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18079826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`} >
                              List of twelve applicants sucessfull in the
                              walk-in-interview held on 11.08.2015 /17.03.2015
                              at IUM, for 5 contractual Medical
                              Officer(Specialist) / 3 OT Nurse / 1 X-ray
                              Technician / 1 ECG Technician and 2 OT Assistant.
                            </a>
                          </td>
                          <td>16.09.2015</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18079926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Merit list of Pharmacist (Contractual full time)
                              recruitment through walk-in interview held on
                              09/06/2015 and 12/06/2015 under Kolkata City NUHM
                              Society,KMC.
                            </a>
                          </td>
                          <td>30.07.2015</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18080026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Merit list of Staff Nurse (Contractual full time)
                              recruitment through walk-in interview held on
                              09/06/2015 under Kolkata City NUHM Society, KMC.
                            </a>
                          </td>
                          <td>22.07.2015</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18080126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Result of Interview dated 30.01.2015 for
                              engagement of full time contractual Medical
                              Officers for Kolkata City NUHM Society .
                            </a>
                          </td>
                          <td>02.06.2015</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default KMC_Results;
